export const LEAD_FORM_BASE_PATH = '/lead-form';
export const LEAD_FORM_TITLE = 'title.lead-form';
export const LEAD_FORM_ICON = '/media/svg/icons/Communication/customer-campaign.svg';
